var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    stroke: "#38393C",
    fill: "#38393C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L17 17",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89746 3.95801C3.43443 5.14988 2.5 6.96581 2.5 9C2.5 12.5899 5.41015 15.5 9 15.5C11.0342 15.5 12.8491 14.5647 14.041 13.1016L15.1055 14.166C13.638 15.8986 11.4484 17 9 17C4.58172 17 1 13.4183 1 9C1 6.55168 2.10047 4.36102 3.83301 2.89355L4.89746 3.95801ZM9 1C13.4183 1 17 4.58172 17 9C17 10.4227 16.6267 11.7575 15.9756 12.915L14.8652 11.8047C15.272 10.9555 15.5 10.0044 15.5 9C15.5 5.41015 12.5899 2.5 9 2.5C7.99542 2.5 7.04358 2.72688 6.19434 3.13379L5.08398 2.02344C6.24161 1.37225 7.5772 1 9 1Z",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesNo);
export default __webpack_public_path__ + "static/media/yes-no.3f305052bda712bb435aa2290b738a87.svg";
export { ForwardRef as ReactComponent };